import { render, staticRenderFns } from "./contract-add-or-update.vue?vue&type=template&id=16fa5241&scoped=true"
import script from "./contract-add-or-update.vue?vue&type=script&lang=js"
export * from "./contract-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./contract-add-or-update.vue?vue&type=style&index=0&id=16fa5241&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fa5241",
  null
  
)

export default component.exports